import { Box, Card, Stack, TextField } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { Editor, EditorState, RichUtils } from 'draft-js';
import 'draft-js/dist/Draft.css';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import ComposeEmailFields from '../../../../../types/ComposeEmailFields';
import InlineStylesButton, {
    InlineStylesButtonProps,
} from '../InlineStylesButton/InlineStylesButton';

const richTextButtons: InlineStylesButtonProps[] = [
    {
        name: 'bold',
        ariaLabel: 'Toggle bold text',
        value: 'BOLD',
    },
    {
        name: 'italic',
        ariaLabel: 'Toggle italic text',
        value: 'ITALIC',
    },
    {
        name: 'underline',
        ariaLabel: 'Toggle underlined text',
        value: 'UNDERLINE',
    },
    {
        name: 'strikethrough',
        ariaLabel: 'Toggle strikethrough text',
        value: 'STRIKETHROUGH',
    },
];

interface Props {
    subjectValue: string;
    ccValue?: string;
    bccValue?: string;
    editorState: EditorState;
    isDisabled: boolean;
    onUpdateHandler: React.Dispatch<Partial<ComposeEmailFields>>;
}

export default function ComposeEmailRaw({
    subjectValue,
    ccValue,
    bccValue,
    editorState,
    isDisabled,
    onUpdateHandler,
}: Props) {
    const { classes } = useStyles();

    const editorRef = React.useRef<Editor | null>(null);

    const handleChangeSubject = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
        onUpdateHandler({ [event.target.name]: event.target.value });
    };

    const handleChangeEditor = (editorState: EditorState) => {
        onUpdateHandler({ editor: editorState });
    };

    const handleToggleInlineStyle = (event: React.MouseEvent<HTMLButtonElement>) => {
        /* 
            Prevent Draft.js editor from losing focus when RichText button is clicked.

            TIP: RichText styles are applied to text written after the cursor position. If 
            focus on the editor is lost the RichText styling will not be applied.
         */
        event.preventDefault();

        editorRef.current && editorRef.current.focus();

        onUpdateHandler({
            editor: RichUtils.toggleInlineStyle(editorState, event.currentTarget.value),
        });
    };

    const [bccCcExpanded, setBccCcExpanded] = React.useState<boolean>(false);

    /*const handleChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
            setExpanded(isExpanded ? panel : false);
    };*/

    const handleBccCc = (event: React.MouseEvent<HTMLButtonElement>) => {
        if (!isDisabled) {
            setBccCcExpanded(!bccCcExpanded);
        }
    };

    return (
        <>
            <TextField
                name="subject"
                fullWidth
                size="small"
                placeholder="Subject"
                label="Subject"
                value={subjectValue}
                disabled={isDisabled}
                className={classes.txtInput}
                // InputProps={{
                //     endAdornment: !bccCcExpanded && (
                //         <InputAdornment position="end">
                //             <Button onClick={handleBccCc}>BCC &amp; CC</Button>
                //         </InputAdornment>
                //     ),
                // }}
                onChange={handleChangeSubject}
            />
            {/* {bccCcExpanded && !isDisabled && (
                <>
                    <TextField
                        name="cc"
                        fullWidth
                        size="small"
                        placeholder="CC"
                        label="CC"
                        value={ccValue}
                        type="email"
                        onChange={handleChangeSubject}
                        className={classes.txtInput}
                    />
                    <TextField
                        name="bcc"
                        fullWidth
                        size="small"
                        placeholder="BCC"
                        label="BCC"
                        value={bccValue}
                        type="email"
                        onChange={handleChangeSubject}
                        className={classes.txtInput}
                    />
                </>
            )} */}
            <Stack spacing={1} direction="row">
                {richTextButtons.map(itm => (
                    <InlineStylesButton
                        key={itm.name}
                        editorState={editorState}
                        config={itm}
                        isDisabled={isDisabled}
                        onClickHandler={handleToggleInlineStyle}
                    />
                ))}
            </Stack>
            <Box>
                <Card
                    elevation={0}
                    className={classes.paper}
                    variant="outlined"
                    onClick={() => {
                        editorRef?.current?.focus();
                    }}
                >
                    <Editor
                        ref={editorRef}
                        editorState={editorState}
                        onChange={handleChangeEditor}
                        placeholder={'Compose Email'}
                        readOnly={isDisabled}
                    />
                </Card>
            </Box>
        </>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    sendWrapper: {
        marginLeft: theme.spacing(1),
    },
    sendButton: {
        /* maintain x-axis padding; modify y-axis padding to match Mui-TextField height */
        padding: '7px 15px',
    },
    buttonGroup: {
        padding: theme.spacing(1),
    },
    paper: {
        height: '100%',
        padding: theme.spacing(1),
        overflowY: 'auto',
        cursor: 'text',
        // border: `1px solid ${theme.palette.divider}`,

        ' .DraftEditor-root': {
            minHeight: '200px',
            maxHeight: '40vh',
            height: '100%',
        },
        ' .DraftEditor-editorContainer': {
            height: '100%',
        },
    },
    txtInput: {},
}));
